import React, { Component } from 'react';
import HeaderActionType from '../../enums/action-types/HeaderActionType';
import GLOBAL_CONFIG from '../../config/config';
//import '.././App.css';
import GlobalStoreService from '../../services/global-store.service'

class Header extends Component {
    constructor(props){
        super(props);
        this.state = {
            isMinimized: false
        };
    }

    componentWillReceiveProps(new_props){
        if(new_props.isMinimized!== this.state.isMinimized){
            this.setState({isMinimized:new_props.isMinimized})
        }
    }


  render() {
       
        let handleHeaderClick = (data) => {
            if(data.actionType === HeaderActionType.MINIMIZE) {
                if (!GlobalStoreService.get("APP_CONTEXT")) {
                    window.parent.postMessage("MINIMIZE", GLOBAL_CONFIG.parentOrigin);
                }
                this.setState ({
                    isMinimized: true
                });

            } else if (data.actionType === HeaderActionType.MAXIMIZE) {
                if (!GlobalStoreService.get("APP_CONTEXT")) {
                    window.parent.postMessage("MAXIMIZE", GLOBAL_CONFIG.parentOrigin);
                }
                this.setState ({
                    isMinimized: false
                });
            } 
            this.props.handleHeaderClick(data);
        }
        return (
            <section className="top-bar">
                <span className="color-white display-block fs-17">Airtel Support</span>
                <span style={{float:"left"}}>
                    { !this.state.isMinimized ?
                        (<img 
                        style={{marginLeft: "10px", marginRight:"10px",paddingBottom:"2px"}} 
                        height="20px" 
                        width="20px" 
                        src={`${process.env.PUBLIC_URL}/assets/images/minimize.svg`} 
                        onClick={()=>{
                            handleHeaderClick(
                                    {  
                                        actionType: HeaderActionType.MINIMIZE
                                    }
                                ) 
                            }
                        }/>)
                        :
                        (<img 
                        style={{ marginLeft: "10px", marginRight: "10px"}} 
                        height="20px" width="20px" 
                        src={`${process.env.PUBLIC_URL}/assets/images/expand.png`} 
                        onClick={()=>{
                            handleHeaderClick(
                                    {  
                                        actionType: HeaderActionType.MAXIMIZE
                                    }
                                ) 
                            }
                        }
                        />)
                    }
                    <img 
                    style={{ marginLeft: "10px"}} 
                    height="20px" width="20px" 
                    src={`${process.env.PUBLIC_URL}/assets/images/close.png`}
                    onClick={()=>{
                        handleHeaderClick(
                                {  
                                    actionType: HeaderActionType.CLOSE
                                }
                            ) 
                        }
                    }
                    />
                </span>
               
            </section>
        );
  }
}

export default Header;




// WEBPACK FOOTER //
// ./src/components/header-components/header.component.js